(function ($, Drupal) {
  Drupal.behaviors.initCarousel = {
    attach: function (context) {

      once('slickInit', '.slick-slider', context).forEach((slider) => {
        $(slider)
          .on('init setPosition afterChange breakpoint', function () {
            setEqualCarouselHeight();
          })
          .slick({
            infinite: false,
            dots: false,
            slidesPerRow: 2,
          });
      });
      
      function setEqualCarouselHeight() {
        let maxHeight = 0;
        const $items = $('.carousel-item:not(.slick-cloned)');
      
        $items.css('height', 'auto');
      
        $items.each(function () {
          const h = $(this).outerHeight(true);
          if (h > maxHeight) {
            maxHeight = h;
          }
        });
      
        $items.css('height', maxHeight + 'px');
      }
      
      $(window).on('load', function () {
        setEqualCarouselHeight();
      });
      
      let resizeTimer;
      $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          $('.slick-slider').slick('setPosition');
          setEqualCarouselHeight();
        }, 150);
      });

    }
  };
})(jQuery, Drupal);
